import axios from 'axios';
import Axios from 'axios/lib/core/Axios';
import utils from 'axios/lib/utils';
import findIndex from 'lodash/findIndex';
import isArray from 'lodash/isArray';
import uniqueId from 'lodash/uniqueId';
import isPlainObject from 'lodash/isPlainObject';
import InterceptorManager from 'axios/lib/core/InterceptorManager';
import { setInterceptors } from '@kso/axios/lib/util';
export { default as Cancel } from 'axios/lib/cancel/Cancel';

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var _axios_ = axios;
var _create_ = _axios_.create;

function $ejectAll() {
  this.interceptors.request.$ejectAll();
  this.interceptors.response.$ejectAll();
}

function $inject(interceptor) {
  var _ref = interceptor || {},
      name = _ref.name;

  if (!name) {
    console.error('使用Axios实例的$inject的参数必须指定name');
  } else {
    return setInterceptors(this, interceptor);
  }
}

function addInjector(factory) {
  var args = Array.from(arguments).splice(1); //全局的方法只插入一次

  if (_axios_ === this) {
    this._added__ = this._added__ || [];
    factory.apply(this, args);
  } else {
    factory.apply(this, args);
  }
}

InterceptorManager.prototype.unshiftUse = function unshiftUse(fulfilled, rejected, refer) {
  var __ID__ = uniqueId();

  var handle = {
    __ID__: __ID__,
    refer: refer,
    fulfilled: fulfilled,
    rejected: rejected
  };

  if (refer) {
    var index = findIndex(this.handlers, function (handle) {
      return handle && handle.refer === refer;
    });

    if (~index) {
      this.handlers.splice(index, 1, handle);
    } else {
      this.handlers.unshift(handle);
    }
  } else {
    this.handlers.unshift(handle);
  }

  return __ID__;
};

InterceptorManager.prototype.use = function use(fulfilled, rejected, refer) {
  var __ID__ = uniqueId();

  var handle = {
    __ID__: __ID__,
    refer: refer,
    fulfilled: fulfilled,
    rejected: rejected
  };

  if (refer) {
    var index = findIndex(this.handlers, function (handle) {
      return handle && handle.refer === refer;
    });

    if (~index) {
      this.handlers.splice(index, 1, handle);
    } else {
      this.handlers.push(handle);
    }
  } else {
    this.handlers.push(handle);
  }

  return __ID__;
};

InterceptorManager.prototype.eject = function use(id) {
  var index = findIndex(this.handlers, function (handle) {
    return handle && handle.__ID__ === id;
  });

  if (this.handlers[index]) {
    this.handlers[index] = null;
  }

  this.handlers = this.handlers.filter(function (i) {
    return i;
  });
};

InterceptorManager.prototype.forEach = function forEach(fn) {
  var globalAxiosHandlers = [];
  var defaults = []; //使用标记

  var isRequestRuntime = this._type_ === 'request';
  var isResponseRuntime = this._type_ === 'response';
  var handlers = Array.from(this.handlers);

  if (isRequestRuntime) {
    if (this.accordanceWithGlobal) {
      globalAxiosHandlers = Array.from(_axios_.interceptors.request.handlers);
    }

    defaults = Array.from(_axios_.defaults.$interceptors.request.handlers);
  } else if (isResponseRuntime) {
    if (this.accordanceWithGlobal) {
      globalAxiosHandlers = Array.from(_axios_.interceptors.response.handlers);
    }

    defaults = Array.from(_axios_.defaults.$interceptors.response.handlers);
  } //前置response


  if (isResponseRuntime) {
    var refers = handlers.reduce(function (pre, cur, index) {
      if (cur && cur.refer) pre.push({
        handle: cur,
        index: index
      });
      return pre;
    }, []); //以当前注册的refer为准

    if (refers.length) {
      var temp = Array.from(globalAxiosHandlers);
      temp.forEach(function (globalHandle, index) {
        var custom = refers.find(function (_ref2) {
          var handle = _ref2.handle;
          return handle.refer === globalHandle.refer;
        });

        if (custom) {
          globalAxiosHandlers.splice(index, 1, custom.handle);
          handlers.splice(custom.index, 1, null);
        }
      });
    }
  } else if (isRequestRuntime) {
    globalAxiosHandlers = globalAxiosHandlers.filter(function (handle) {
      var refers = handlers.reduce(function (pre, cur, index) {
        if (cur && cur.refer) pre.push(cur.refer);
        return pre;
      }, []);
      return handle && (!handle.refer || !~refers.indexOf(handle.refer));
    });
  }

  var all = [].concat(_toConsumableArray(globalAxiosHandlers), _toConsumableArray(defaults), _toConsumableArray(handlers));
  utils.forEach(all, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

InterceptorManager.prototype.$ejectAll = function ejectAll() {
  this.handlers = [];
};

Axios.prototype.addInjector = addInjector; //覆盖注入过的 name

Axios.prototype.$inject = $inject;
Axios.prototype.$ejectAll = $ejectAll;
_axios_.defaults.$interceptors = {
  request: new InterceptorManager(),
  response: new InterceptorManager()
};
_axios_.addInjector = addInjector;
_axios_.$inject = $inject;
_axios_.$ejectAll = $ejectAll;
_axios_.interceptors.request._type_ = 'request';
_axios_.interceptors.response._type_ = 'response';

_axios_.create = function (config) {
  var _ref3 = config || {},
      accordanceWithGlobal = _ref3.accordanceWithGlobal,
      interceptors = _ref3.interceptors;

  var instance = _create_.apply(_axios_, arguments); //根据create传入的参数是否忽略挂载在Axios上的interceptor
  //如果有需要需要自己为单个实例创建interceptor


  if (accordanceWithGlobal) {
    instance.interceptors.request.accordanceWithGlobal = true;
    instance.interceptors.response.accordanceWithGlobal = true;
  }

  instance.interceptors.request._type_ = 'request';
  instance.interceptors.response._type_ = 'response';

  var _inject_ = function _inject_(injector) {
    if (typeof injector === 'function') {
      injector.call(instance);
    } else if (isPlainObject(injector)) {
      instance.$inject(injector);
    }
  };

  if (isArray(interceptors)) {
    interceptors.forEach(function (i) {
      return _inject_(i);
    });
  } else if (interceptors) {
    _inject_(interceptors);
  }

  return instance;
};

export default _axios_;
